function setProtocol(url, protocol) {
  if (url.startsWith("http"))
    return url.replace(/^https?/, protocol);
  return `${protocol}://${url}`;
}
export {
  setProtocol as default
};
